<template>
  <InnerPageLayout>
    <section class="method">
      <div class="wrap">
        <PageTitle>活動辦法</PageTitle>

        <div class="content">
          <AppSubtitle>活動日期</AppSubtitle>
          <div class="text">
            <p>2022/03/01(二) 00:00起至2022/03/31(四) 23:59止。</p>
          </div>

          <AppSubtitle>活動辦法</AppSubtitle>
          <div class="text">
            <p>
              活動期間在【「可爾必思」開心成長
              開心郊遊趣】活動網站，登錄隨產品附贈活動紙上的序號集點，集滿指定點數，即可兌換開心成長童趣好禮，還有Peace兒童相機、全家福寫真等你抽！
            </p>
            <ul>
              <li>
                隨瓶附贈活動紙商品：開心成長「可爾必思」乳酸菌飲料(利樂包160ml/6入裝)、開心成長「可爾必思」蘋果乳酸菌飲料(利樂包160ml/6入裝)。
              </li>
              <li>
                每1組序號為1點，每1點限用1次，可選擇抽獎或兌換開心成長童趣好禮。
              </li>
              <li>
                序號點數需於2022年03月31日前登錄參加活動，逾期點數無效，並視同自行放棄參與權益。
              </li>
              <li>
                請妥善保留登錄序號的活動紙，序號驗證有問題時，需提供活動紙進行複查。
              </li>
            </ul>
          </div>

          <AppSubtitle>兌換/抽獎贈品</AppSubtitle>
          <div class="text">
            <h3 class="small_title">集點兌換</h3>
            <p>集到指定點數即可兌換下列開心郊遊趣童趣好禮。</p>
            <ul>
              <li>
                開心握水槍：累積8點兌換1組。
                <span style="display: block">
                  (超酷手腕水槍，變身水槍蜘蛛人)
                </span>
              </li>
              <li>
                開心玩保齡：累積15點兌換1組。
                <span style="display: block"
                  >(好攜帶保齡組，走哪都可strike！)</span
                >
              </li>
              <li>
                開心棒揮棒組：累積20點兌換1組。
                <span style="display: block"
                  >(含內容物：發球機1組+球棒1組+球3個)</span
                >
              </li>
            </ul>
            <h3 class="small_title">集點抽獎</h3>
            <ul>
              <li>
                Peace 兒童相機：1點即可參加抽獎，共3組。<span
                  style="display: block"
                  >(高清1080P兒童專用相機，可拍照和錄影，內建趣味相框，小小攝影師，從這裡開始)</span
                >
              </li>
              <li>
                全家福寫真：1點即可參加抽獎，共1組。<span style="display: block"
                  >(由專業攝影師戶外拍攝，並可獲得20組寫真照電子檔)</span
                >
              </li>
            </ul>
            <h3 class="small_title" style="color: #269e3d">
              參加全家福寫真抽獎注意事項：
            </h3>
            <ul>
              <li>參與拍攝人數限6人，且需包含孩童。</li>
              <li>參加拍攝孩童年齡需6 ~ 10歲為主。</li>
              <li>
                需先提供參加寫真拍攝之家族合照，如於<span class="underline"
                  >一週內未提供照片</span
                >將退回點數，視同取消參加抽獎。
              </li>
              <li>
                參與拍攝即同意成為「可爾必思」開心成長宣傳大使，家庭寫真照需永久無償授權於台灣朝日飲料股份有限公司「可爾必思」系列產品行銷全媒體宣傳使用。
              </li>
              <li>
                全家福寫真拍攝地點預計於台北市，將與中獎者協調可拍攝時間。
              </li>
              <li>中獎者需自行準備服裝與鞋款。</li>
            </ul>
            <p style="margin-top: 2rem">
              ※兌換與抽獎贈品以實物為主，不得挑款。參加者對於本活動抽獎結果應予以尊重，不得異議，如有疑慮請自行斟酌是否參加。
            </p>
          </div>

          <AppSubtitle>領獎方式與注意事項</AppSubtitle>
          <div class="text">
            <h3 class="small_title">兌換領獎</h3>
            <p>
              兌換〈開心握水槍〉、〈開心玩保齡〉、〈開心揮棒組〉贈品者，兌換作業審核完成後，將於活動結束後寄出贈品。
            </p>

            <h3 class="small_title">抽獎領獎</h3>
            <p>
              本活動預計於2022年4月15日公告中獎者於活動網站，請密切鎖定活動網站。
            </p>
            <ul>
              <li>
                <span>Peace 兒童相機</span>
                <p>
                  中獎者請於2022年4月22日前以email或私訊<AppLink
                    to="https://www.facebook.com/calpis.tw"
                    ga="activity-fb"
                    >「Happy可爾必思」Facebook粉絲專頁</AppLink
                  >，開心成長活動小組將於審核中獎資訊無誤後提供機會中獎回函，並請中獎人完整填寫(含親筆簽名)後，選擇下列任一種方式於寄回活動小組：
                </p>
                <ul>
                  <li>
                    紙本郵寄：將領獎回函掛號寄至
                    10692台北市大安區忠孝東路四段285號4樓(開心成長活動小組收)
                  </li>
                  <li>
                    電子郵件：掃描寄回領獎回函至客服信箱
                    <a href="mailto:happycalpistw@mail.asahisoftdrinks.com.tw"
                      >happycalpistw@mail.asahisoftdrinks.com.tw</a
                    >
                  </li>
                  <li>傳真：將領獎回函傳真至02-2656-1285</li>
                </ul>
                <p>
                  領獎回函收件截止日：2022年5月3日止(紙本以郵戳為憑)，逾期視同自動放棄權利，活動小組將另抽出新得獎人。活動小組收到領獎回函並確認無誤後，安排寄出贈品。
                </p>
              </li>
              <li>
                <span>全家福寫真(含電子檔20組)</span>
                <p>
                  中獎者請於2022年4月22日前以email或私訊<AppLink
                    to="https://www.facebook.com/calpis.tw"
                    ga="activity-fb"
                    >「Happy可爾必思」Facebook粉絲專頁</AppLink
                  >，開心成長活動小組審核中獎資訊無誤並確認中獎人意願後，提供勞務報酬單(金額$15,000元)、拍攝同意書及肖像授權同意書，請中獎人完整填寫(含親筆簽名)後，將上述文件交付或寄回活動小組(10692台北市大安區忠孝東路四段285號4樓
                  開心成長活動小組收)。
                </p>
                <p>
                  領獎文件收件截止日：2022年5月3日止(紙本以郵戳為憑)，逾期視同自動放棄權利，活動小組將另抽出新得獎人。活動小組收到上述文件並確認無誤後，安排全家福寫真攝影。
                </p>
              </li>
            </ul>

            <h3 class="small_title">兌換/中獎 領獎注意事項</h3>
            <ol>
              <li>
                活動小組將以兌換獎項消費者於活動流程填寫之個人資料聯繫後續領獎事宜，如因資料提供不全或不確實以致無法聯絡領獎者，視同放棄領獎資格。主辦單位不另行通知，並抽出新得獎人遞補。
              </li>
              <li>
                贈品將以郵局包裹寄出，運送地址請詳實填寫，若因地址或個人相關資料不完整，導致贈品無法寄送、投遞不成功、退件、無人簽收、無法聯絡中獎者等因素，視同放棄兌獎資格，中獎者不得要求主辦單位補償，主辦單位對於任何不實或不正確之資料亦不負任何法律責任。
              </li>
              <li>
                依中華民國稅法規定，獎項價值NT$1,001元(含)以上者，需繳交身分證影本供報稅使用，並於次年列入本年度之個人綜合所得稅申報，主辦單位將不再另外寄發紙本中獎所得扣繳憑單。獎項價值超過NT$20,000元，依法需預先繳交10％機會中獎稅金。中獎者若不願意配合，則視為自動棄權，不具中獎資格。中獎者同意依台灣相關稅法規定繳納稅捐，並同意主辦單位得依相關法令代扣(繳納)相關稅捐。
              </li>
              <li>
                所有獎品將在主辦單位確認中獎者符合資格，於活動結束後寄出。若中獎者為未成年人，需附上未成年中獎者之身分證正反面影本、法定代理人身分證正反面影本。若未成年人無國民身分證者，另須提供中獎者戶口名簿影本或戶籍謄本正本(須為3個月內核發之版本)。若為外籍人士，需檢附護照影本。如因中獎回函或聯絡資料提供不全、不確實或逾期回覆以致無法聯絡中獎者，視同中獎者放棄中獎資格。主辦單位不另行通知，並抽出新得獎人遞補。
              </li>
            </ol>
          </div>

          <AppSubtitle>活動注意事項</AppSubtitle>
          <div class="text">
            <ol>
              <li>
                參加者於參與本活動之同時，即表示同意接受本活動之活動辦法與注意事項之規範；如有違反，主辦單位得取消其中獎資格，並對於任何破壞本活動之行為保留法律追訴權。若您為未滿20歲之未成年人，應於您的法定代理人(或監護人)閱讀、瞭解並同意本活動之所有內容後，方得參加本活動。當您參加本活動時，即視為您的法定代理人(或監護人)已閱讀、瞭解並同意接受本活動之所有內容規範。
              </li>
              <li>
                參加者保證所有填寫或提出之資料均為真實、正確，如因中獎者之資料不實或填寫不正確或不完整或無法辨識等問題導致無法兌獎者，視同中獎者自願放棄中獎資格，獎項將不另行補發，主辦單位不負任何責任；若因逾期兌獎者，視同自行放棄並不得異議。且如有致損害於主辦單位或其他任何第三人，參加者應負一切相關責任。
              </li>
              <li>
                主辦單位有權檢視各活動參加者之參與行為及中獎情形是否涉嫌不法或有違常理之異常狀況，例：人為操作蓄意偽造、短時間異常多筆參與行為、透過任何電腦程式參與活動、詐欺或以任何其他不正當的方式意圖以進行不實或虛偽活動參與行為、或登錄資料不實或不正確或盜用任何第三人之資料，或有違反活動規範之行為等。活動參加者因上述情形所獲得之活動資格及獎品，主辦單位及活動小組保有變更、終止參加活動資格、取消中獎資格或暫停活動的權利，並保留法律追訴權。
              </li>
              <li>
                本活動之所有獎品不得轉換、轉讓或折換現金。獎項以公佈於本頁面上的資料為準，如遇不可抗力之因素，主辦單位保留更換其他等值獎項之權利。
              </li>
              <li>
                獎項以公佈於本活動辦法網頁上的資料為準，主辦單位保留修改活動獎項細節的權利，無須事前通知，並有權對本活動所有事宜作出解釋或裁決。
              </li>
              <li>
                中獎者須遵守各獎品供應商所列有關獎品之各項條款及細則，如有相關使用疑問，請洽各獎品供應商，主辦單位對所有領取或使用獎品等事宜，概不負責。
              </li>
              <li>
                如有任何因網路、電子產品(包括但不限於任何其他得登入本活動參與抽獎之電子產品。例如：電腦、IPAD、手機)、技術或不可歸責於主辦單位之事由，而使參加者所登錄之資料有延遲、遺失、錯誤、無法辨識或毀損之情況，主辦單位不負任何法律責任，參加者亦不得因此異議。
              </li>
              <li>
                本活動限中華民國台灣地區(台澎金馬)之居民參加。獎品寄送亦限於中華民國台灣地區(台澎金馬)。贈品一經寄送，主辦單位不負贈品無法送達及寄送時發生損毀之責任。
              </li>
              <li>
                主辦單位保留取消、變更或解釋活動內容之權利。如有任何爭議，主辦單位保留最終裁決權。
              </li>
              <li>
                本活動由「台灣朝日飲料股份有限公司」發起，並委由「聯眾廣告股份有限公司」執行。如對活動有任何疑問，請於2022年03月31日(四)前撥打活動諮詢專線<a
                  href="tel:0226576963"
                >
                  02-2657-6963 </a
                >或私訊<AppLink
                  to="https://www.facebook.com/calpis.tw"
                  ga="activity-fb"
                  >「Happy可爾必思」粉絲團</AppLink
                >。(聯眾廣告股份有限公司「開心成長」活動小組，服務時間周一~周五，10:00~12:00/14:00~17:00，例假日及國定假日暫不提供服務)。
              </li>
              <li>
                所有參加本活動者於提供或填寫個人資料後，視為同意主辦單位、活動執行單位得將其個人資料於本活動目地範圍內蒐集、處理暨使用之。主辦單位僅使用參加者所提供之個人資料於此次活動用途，且遵守【個人資料保護法】相關規定，以維護參加者權益。詳細告知內容請參閱以下個人資料告知事項暨同意書。
              </li>
            </ol>
          </div>

          <AppSubtitle>個人資料告知事項暨同意書</AppSubtitle>
          <div class="text">
            <p>依據個人資料保護法等相關規定，以下告知事項請台端詳閱：</p>
            <ol>
              <li>
                告知事項：
                <ol>
                  <li>
                    蒐集個人資料公司：聯眾廣告股份有限公司(以下簡稱本公司)。
                  </li>
                  <li>
                    蒐集之目的：作為參與【「可爾必思」開心成長開心郊遊趣】(以下簡稱本活動)、後續聯繫及稅務處理使用。
                  </li>
                  <li>
                    個人資料之類別：可辨識參加者之姓名、性別、聯絡電話、寄件地址等。
                  </li>
                  <li>
                    個人資料利用之期間：本活動起始日起至本活動兌獎程序執行完畢之日止。
                  </li>
                  <li>
                    個人資料利用之地區：本公司營運範圍，僅限於台灣、金門、澎湖、馬祖等地區利用，且不會移轉至其他境外地區利用。
                  </li>
                  <li>
                    個人資料利用之對象及方式：由本公司該業務承辦人員於辦理本活動之特定目的必要範圍內，依通常作業所必要之方式利用此個人資料。
                  </li>
                  <li>
                    依個人資料保護法第三條規定台端得行使之權利及方式：台端得向本公司承辦該項業務單位聯眾廣告股份有限公司提出申請(服務電話：<a
                      href="tel:0226576963"
                      >02-2657-6963</a
                    >，服務時間:周一~周五，10:00~12:00/14:00~17:00，例假日及國定假日暫不提供服務)，以查詢、閱覽、製給複製本；或補充／更正、請求停止蒐集、處理、利用或刪除個人資料內容之一部或全部。(註：參加者申請查詢、閱覽、製給複製本時，將酌收必要成本費用。)
                  </li>
                  <li>
                    本活動所獲得的個人資訊與您的社群帳號不會被作為其他任何使用，僅供本次活動使用。
                  </li>
                </ol>
              </li>
              <li>
                台端填寫個人資料後，以任何方式遞送至本公司收執時，均視為台端已同意其所填寫之個人資料，供本公司於辦理本活動之特定目的必要範圍內處理及利用；此外，台端可自行決定是否填寫相關之個人資料欄位，若台端選擇不願填寫，將無法參加本次活動所提供之相關服務。
              </li>
              <li>
                本人參與本活動即視為本人已瞭解活動以上告知事項，並已清楚瞭解貴公司蒐集、處理及利用本人個人資料之目的及用途，並同意貴公司於上述告知事項範圍內，得蒐集、處理、傳遞及利用本人資料。
              </li>
            </ol>
          </div>

          <div class="btns">
            <AppButton :to="{ name: 'home' }" ga="activity-back-to-home">
              <span>返回首頁</span>
            </AppButton>
          </div>
        </div>
      </div>
    </section>
  </InnerPageLayout>
</template>

<script>
import InnerPageLayout from '@/layouts/InnerPageLayout';
import PageTitle from '@/components/PageTitle';
import AppSubtitle from '@/components/AppSubtitle';
import AppButton from '@/components/AppButton';
import AppLink from '@/components/AppLink';

export default {
  components: {
    InnerPageLayout,
    PageTitle,
    AppSubtitle,
    AppButton,
    AppLink,
  },
};
</script>

<style lang="scss">
@import './Activity.scss';
</style>
